import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { PersonSearchResultModel } from "../models/person/person-search-result.model";
import { TrainingInvitationSearchModel } from "../models/training/training-invitation-search.model";
import { TrainingMessageSendModel } from "../models/training/training-message-send.model";
import { LearningPathMessageSendModel } from "../models/learning-path/learning-path-message-send.model";

@Injectable({
    providedIn: 'root'
})
export class LearningPathMessageService {

    constructor(private httpClient: HttpClient) {
    }
    
    sendInvitation(learningPathId: string, model: LearningPathMessageSendModel): Observable<any> {
        const params = new HttpParams()
            .set('learningPathId', learningPathId);
        
        return this.httpClient.post<void>(
            Configuration.getApiBaseUrl() + "/learningpathmessage/invitation",
            model,
            { params: params }
        );
    }
}